__turbopack_context__.v({
  "award": "CardProduct-module-scss-module__Li9ZcG__award",
  "card": "CardProduct-module-scss-module__Li9ZcG__card",
  "cardContent": "CardProduct-module-scss-module__Li9ZcG__cardContent",
  "cardInner": "CardProduct-module-scss-module__Li9ZcG__cardInner",
  "cardInner--dark-text": "CardProduct-module-scss-module__Li9ZcG__cardInner--dark-text",
  "cardLinkWrap": "CardProduct-module-scss-module__Li9ZcG__cardLinkWrap",
  "cta": "CardProduct-module-scss-module__Li9ZcG__cta",
  "eyebrow": "CardProduct-module-scss-module__Li9ZcG__eyebrow",
  "fade-in": "CardProduct-module-scss-module__Li9ZcG__fade-in",
  "favoriteButtonContainer": "CardProduct-module-scss-module__Li9ZcG__favoriteButtonContainer",
  "icon": "CardProduct-module-scss-module__Li9ZcG__icon",
  "iconPlacement": "CardProduct-module-scss-module__Li9ZcG__iconPlacement",
  "image": "CardProduct-module-scss-module__Li9ZcG__image",
  "imageContainer": "CardProduct-module-scss-module__Li9ZcG__imageContainer",
  "isInCarousel": "CardProduct-module-scss-module__Li9ZcG__isInCarousel",
  "isVisible": "CardProduct-module-scss-module__Li9ZcG__isVisible",
  "textGroup": "CardProduct-module-scss-module__Li9ZcG__textGroup",
  "theme--makers-reserve": "CardProduct-module-scss-module__Li9ZcG__theme--makers-reserve",
});
